import { ITree } from "@/tree/ITree";
import { IWykrojnikParams } from "./IWykrojnikParams";
import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();

export class WykrojnikParamsSvc  {
public static async fill_restrictions_from_tree(wp:IWykrojnikParams, tree:ITree) {
    const wpp = await bus.call("/api/wp/fill_restrictions_from_tree",{ wp: wp,tree:tree });
    if (!wpp) return;
    if (!wpp.szerokosci) return;
    return wpp;
  }
}
